import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { Navbar } from "./Navbar";
import { Footer } from "./Footer";
import { api } from "../lib/api";
import { Sparkles } from "lucide-react";

export default function Layout() {
  const [promo, setPromo] = useState(null);

  useEffect(() => {
    api.get("/content/promo-banner").then((r) => {
      if (r.data && r.data.title) setPromo(r.data);
    }).catch(() => {});
  }, []);

  return (
    <div className="min-h-screen bg-[#050505] text-white">
      {promo && (
        <div data-testid="promo-banner" className="relative z-50 bg-gradient-to-r from-indigo-600 to-indigo-500 text-white text-sm text-center py-2 px-4 flex items-center justify-center gap-2">
          <Sparkles className="w-4 h-4" />
          <span className="font-medium">{promo.title}</span>
          {promo.cta_label && promo.cta_url && (
            <a href={promo.cta_url} className="underline font-semibold">{promo.cta_label}</a>
          )}
        </div>
      )}
      <Navbar />
      <main className={promo ? "pt-0" : ""}>
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
